import { makeAutoObservable, observable, action, computed } from "mobx"
import { API } from "../API";
import { createRouterState, RouterStore } from "mobx-state-router"
import { routes } from "../routing/routes";
import { CustomerEmployeeProfile, EmployeeProfile, UserProfile } from "../data/UserProfile";
import { UserType } from "../data/UserType";
import { eventbus } from "../event-bus/eventbus";
import { Timesheet } from "../data/Timesheet";

const notFound = createRouterState("notFound")

export class GlobalError {
    code: number = 0;
    message: string = '';
    set = (code: number, message: string) => { this.code = code; this.message = message; }
    reset = () => { this.code = 0; this.message = ''; }
    constructor() {
        makeAutoObservable(this, {
            code: observable,
            message: observable,
            set: action,
            reset: action,
        })
    }
}

export class RootStore {

    public isLoading: boolean = false;

    public timesheetsChannel = eventbus<{
        onTimesheetAdded: (payload: Timesheet) => void
    }>()

    public issuesChannel = eventbus<{
        onIssueChanged: (issueID: number) => void
    }>()

    public scheduleChannel = eventbus<{
        onScheduleChanged: (employeeID: number) => void
    }>()

    setLoading = (isLoading: boolean) => this.isLoading = isLoading;

    public isLogged: boolean = false;

    public setUserProfile = (profile: UserProfile | undefined) => {
        if (profile) {
            localStorage.setItem('userProfile', JSON.stringify(profile));
        } else {
            localStorage.removeItem('userProfile');
        }
        this.userProfile = profile;
    }

    public userProfile: UserProfile | undefined;

    public get activityStarted(): boolean { return this.activityStartTime !== null };

    public activityStartTime: Date | null = (() => {
        const ds = parseInt(localStorage.getItem('activityStartedAt') ?? 'not a number', 10);
        return isNaN(ds) ? null : new Date((ds as number) * 1000);
    })();

    public logIn(userProfile: UserProfile) {        
        document.cookie = `UltimaAuthCookie=${userProfile.Token}; path=/`;

        this.setUserProfile(userProfile);

        if (userProfile.UserType === UserType.Employee) {
            this.api.getActiveIssueID().then(id => {
                (userProfile as EmployeeProfile).ActiveIssueId = id;                
                this.api.getAvatar(userProfile.ID).then(a => {
                    userProfile.Avatar = a;
                    this.setUserProfile(userProfile);
                    this.isLogged = true;
                });
            });            
        } else {
            this.isLogged = true;
        }

        if (this.routerStore.getCurrentRoute()?.name == 'login') {
            window.location.href = 'dashboard';
        }

        return true;
    }

    public logOut() {
        document.cookie = "UltimaAuthCookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        this.setUserProfile(undefined);
        if (this.routerStore.routerState.routeName != 'login') {
            this.goTo('login');
        }
    }

    public setActivityStartTime = (startTime: Date | null) => {
        if (startTime) {
            const ms = Math.floor(startTime.getTime() / 1000);
            localStorage.setItem('activityStartedAt', ms.toString());
            this.activityStartTime = startTime;
        } else {
            localStorage.removeItem('activityStartedAt');
            this.activityStartTime = null;
        }
    }

    public globalError = new GlobalError();

    public api = new API(this);

    public routerStore = new RouterStore(routes, notFound, {
        rootStore: this
    })

    goTo = (routeName: string) => this.routerStore.goTo(routeName);

    constructor() {

        makeAutoObservable(this, {
            isLoading: observable,
            isLogged: observable,
            globalError: observable,
            userProfile: observable,
            setUserProfile: action,
            activityStartTime: observable,
            activityStarted: computed,            
            setActivityStartTime: action,
            setLoading: action,
        })

        const ups = localStorage.getItem('userProfile');
        if (ups) {
            const up = JSON.parse(ups);
            this.logIn(up.UserType === UserType.Employee ? up as EmployeeProfile : up as CustomerEmployeeProfile)
        };

        /*const aId = parseInt(localStorage.getItem('agentID') ?? 'not a number', 10);
        this.agentId = isNaN(aId) ? undefined : aId;
        this.agentName = '';*/

        /*autorun(() => console.log("Entered route: " + this.routerStore.routerState.routeName))

        if (this.routerStore.routerState.routeName == '__initial__') {
            console.log('FIRST TIME')
            this.authStore.getUser()
        }*/
    }
}